import { logReportDownload } from '../../util/auditLogger';
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";

import { FiPercent } from "react-icons/fi";
import Context from "../../Context";

import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import * as xlsx from "xlsx";
import { thaiDate } from "../../util";

export const ReportPromoCodeCreated = () => {
  const { callApi, configs } = Context();
  const [promoCodes, setPromoCodes] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState(false);

  const getPromoCodes = async () => {
    setLoading(true);
    const data = await callApi(
      "promocode-getAll",
      {
        roundDate: selectedRoundDate,
        limit: 50000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true }
    );

    // Calculate dashboard logic
    const dash = (data || []).reduce(
      (acc, p) => {
        if (p.type === "discount") {
          acc.discountCount += 1;
          acc.totalDiscountValue += Number(p.discount) || 0;
        } else if (p.type === "voucher") {
          acc.voucherCount += 1;
          acc.totalVoucherQuantity += Number(p.quantity) || 0;
        }
        return acc;
      },
      { discountCount: 0, voucherCount: 0, totalDiscountValue: 0, totalVoucherQuantity: 0 }
    );

    setDashboard(dash);
    setPromoCodes(data || []);
    setLoading(false);
  };

  const handleDownload = async () => {
    const csvData = [
      [`รายงานการสร้างโค้ดส่วนลด_งวด_${selectedRoundDate}_ออก_ณ_วันที่${thaiDate()}`],
      [""],
      [
        "จำนวน Promo Code ทั้งหมด",
        "Promo Code (ส่วนลด)",
        "Promo Code (สลากฟรี)",
        "มูลค่าส่วนลดรวม (บาท)",
        "จำนวนสลากฟรีรวม (ใบ)",
      ],
      [
        promoCodes.length,
        dashboard.discountCount,
        dashboard.voucherCount,
        dashboard.totalDiscountValue,
        dashboard.totalVoucherQuantity,
      ],
      [""],
      [
        "ลำดับ",
        "รหัสโปรโมชั่น",
        "ประเภท",
        "สิทธิประโยชน์",
        "ขั้นต่ำ (ใบ/บาท)",
        "จำกัดการใช้",
        "วันที่สร้าง",
        "ชื่อผู้สร้าง (UserId)",
        "เหตุผล/อ้างอิง",
        "สถานะ",
        "ระยะเวลาใช้งาน",
      ],
    ];

    promoCodes.forEach((p, index) => {
      csvData.push([
        index + 1,
        p.code,
        p.type === "discount" ? "Discount" : "Voucher",
        p.type === "discount" ? `${p.discount} บาท` : `ฟรีสลาก ${p.quantity} ใบ`,
        (p.minimum > 1 ? `ขั้นต่ำ ${p.minimum} ใบ ` : "") +
          (p.minOrderValue > 0 ? `ยอด ${p.minOrderValue} บาท` : ""),
        `${p.usageCount} / ${p.usageLimit !== null ? p.usageLimit : "∞"}`,
        new Date(p.createdAt).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
        p.createdBy?.firstName ? `${p.createdBy.firstName} ${p.createdBy.lastName} (${p.createdBy.userId})` : p.createdBy,
        p.reason || "-",
        p.status === "active" ? "เปิดใช้งาน" : "ปิดใช้งาน",
        `${new Date(p.startDate).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })} ถึง ${new Date(p.endDate).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })}`,
      ]);
    });

    const ws = xlsx.utils.aoa_to_sheet(csvData);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    logReportDownload();
    xlsx.writeFile(
      wb,
      `รายงานการสร้างโค้ดส่วนลด_งวด_${selectedRoundDate}_ออก_ณ_วันที่${thaiDate()}.xlsx`
    );
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      <Header
        header="Report"
        subHeader="รายงานการสร้างโค้ดส่วนลด"
        icon={<FiPercent className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold ">รายงานการสร้าง Promo Code</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-[#E5E7E9] rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getPromoCodes();
            }}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!promoCodes || promoCodes.length === 0}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            ดาวโหลด
          </button>
        </div>
      </div>

      {promoCodes !== false && (
        <div className="grid grid-cols-4 gap-4 mt-4">
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-blue-500">
            <p className="text-sm font-medium text-gray-600">Promo Code ทั้งหมด</p>
            <p className="text-2xl font-bold text-blue-600 mt-2">
              {promoCodes.length.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">รหัส</p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-yellow-500">
            <p className="text-sm font-medium text-gray-600">ประเภท Discount</p>
            <p className="text-2xl font-bold text-yellow-600 mt-2">
              {dashboard.discountCount.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">รหัส</p>
            <p className="text-lg font-semibold text-yellow-600 mt-2">
              {dashboard.totalDiscountValue.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500">มูลค่ารวม (บาท)</p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-purple-500">
            <p className="text-sm font-medium text-gray-600">ประเภท Voucher</p>
            <p className="text-2xl font-bold text-purple-600 mt-2">
              {dashboard.voucherCount.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">รหัส</p>
            <p className="text-lg font-semibold text-purple-600 mt-2">
              {dashboard.totalVoucherQuantity.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500">แจกสลากฟรีรวม (ใบ)</p>
          </div>
        </div>
      )}

      {promoCodes !== false && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">Promo Code ทั้งหมด</p>
            <p className="text-xs font-semibold text-[#969797]">
              {promoCodes.length} รายการ
            </p>
          </div>
          <div className="overflow-y-auto" style={{ height: "600px" }}>
            <Table className="w-full">
              <TableHeader className="bg-[#f2f3f5] sticky top-0 z-10">
                <TableRow>
                  <TableHead className="text-center">ลำดับ</TableHead>
                  <TableHead className="">รหัสโปรโมชั่น</TableHead>
                  <TableHead className="text-center">ประเภท</TableHead>
                  <TableHead className="text-center">สิทธิประโยชน์</TableHead>
                  <TableHead className="text-center">จำกัดการใช้</TableHead>
                  <TableHead className="">วันที่สร้าง</TableHead>
                  <TableHead className="">ชื่อผู้สร้าง</TableHead>
                  <TableHead className="">เหตุผล/อ้างอิง</TableHead>
                  <TableHead className="text-center">สถานะ</TableHead>
                  <TableHead className="">ระยะเวลาใช้งาน</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {promoCodes.length > 0 ? (
                  <>
                    {promoCodes.map((p, index) => {
                      const isExpired = p.endDate && p.endDate < Date.now();
                      const isLimitReached =
                        p.usageLimit !== null && p.usageCount >= p.usageLimit;
                      return (
                        <TableRow key={p.code}>
                          <TableCell className="font-semibold font-mono tabular-nums text-center">
                            {index + 1}
                          </TableCell>
                          <TableCell className="font-bold text-gray-900">
                            {p.code}
                          </TableCell>
                          <TableCell className="text-center font-semibold">
                            {p.type === "discount" ? (
                              <span className="text-blue bg-blue/10 px-2.5 py-1 rounded-full text-xs">
                                Discount
                              </span>
                            ) : (
                              <span className="text-purple bg-purple/10 px-2.5 py-1 rounded-full text-xs text-purple-600">
                                Voucher
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="text-center font-bold text-gray-800">
                            {p.type === "discount"
                              ? `${p.discount?.toLocaleString()} บาท`
                              : `ฟรีสลาก ${p.quantity} ใบ`}
                          </TableCell>
                          <TableCell className="text-center font-semibold">
                            <span
                              className={
                                isLimitReached ? "text-red-500" : "text-gray-700"
                              }
                            >
                              {p.usageCount}
                            </span>
                            <span className="text-gray-400">
                              {p.usageLimit !== null
                                ? ` / ${p.usageLimit}`
                                : " / ∞"}
                            </span>
                          </TableCell>
                          <TableCell className="font-medium text-xs">
                            {new Date(p.createdAt).toLocaleDateString("th-TH", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })} น.
                          </TableCell>
                          <TableCell className="font-semibold font-mono text-xs">
                            {p.createdBy?.firstName ? (
                                <div>
                                  <p className="font-sans">{p.createdBy.firstName} {p.createdBy.lastName}</p>
                                  <p className="text-gray-500 font-mono text-[10px]">{p.createdBy.userId}</p>
                                </div>
                              ) : (
                                p.createdBy
                              )}
                          </TableCell>
                          <TableCell className="text-gray-600 text-xs">
                            {p.reason || "-"}
                          </TableCell>
                          <TableCell className="text-center font-semibold">
                            {p.status === "active" ? (
                              <span className="text-green">เปิดใช้งาน</span>
                            ) : (
                              <span className="text-[#c15b78]">ปิดใช้งาน</span>
                            )}
                          </TableCell>
                          <TableCell className="text-xs text-gray-600">
                            <div>
                              {new Date(p.startDate).toLocaleDateString(
                                "th-TH",
                                {
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric",
                                }
                              )}
                            </div>
                            <div className="text-gray-400 font-bold">ถึง</div>
                            <div
                              className={
                                isExpired ? "text-red-500 font-semibold" : ""
                              }
                            >
                              {new Date(p.endDate).toLocaleDateString("th-TH", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })}
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow className="bg-[#f2f3f5] hover:bg-[#f2f3f5]">
                      <TableCell colSpan={3} className="text-right font-bold">
                        รวมทั้งหมด:
                      </TableCell>
                      <TableCell className="text-center font-bold">
                        {dashboard.totalDiscountValue.toLocaleString()} บาท / ฟรี{" "}
                        {dashboard.totalVoucherQuantity.toLocaleString()} ใบ
                      </TableCell>
                      <TableCell colSpan={6}></TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={10}>
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบข้อมูล Promo Code ในงวดนี้
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );
};
